/**
 * Action for open the save modal.
 */
export function openSave(type) {
    return {
        type: 'SAVE_UPDATE_MODAL_OPEN',
        payload: {
            type,
            action: ACTION.ADD,
            data: null,
        },
    };
}

/**
 * Action for open the update modal.
 * @param {Integer} type Modal type () to be updated.
 * @param {Object} data Data to be passed to the backend.
 * @param {Function} onSuccessCallback Function to be called when the popup has a success.
 */
export function openUpdate(type, data, onSuccessCallback) {
    return {
        type: 'SAVE_UPDATE_MODAL_OPEN',
        payload: {
            type,
            action: ACTION.UPDATE,
            data,
            onSuccessCallback,
        },
    };
}

/**
 * Close the save or update modal.
 */
export function closeSaveUpdate() {
    return {
        type: 'SAVE_UPDATE_MODAL_CLOSE',
    };
}

/**
 * Type of modal.
 */
export const TYPE = {
    CLIENT: 0,
    ACCOUNT: 1,
    PATIENT: 2,
    SUPPLIER: 3,
};

/**
 * Type of actions.
 */
export const ACTION = {
    ADD: 0,
    UPDATE: 1,
};
